module.exports = {"pageTitleText":"任務查詢","submitTime":"提交時間","errorMsg":"錯誤訊息","finishedTime":"完成時間","state":"處理狀態","taskNo":"單號","trainNo":"車號","runCounter":"運行次數","scopeResult":"部署結果","scope":"影響範圍","requestData":"修改資料","originData":"原始資料","diffData":"比較","objId":"物件 ID","decodeObjId":"物件名稱","request_source":"請求來源","actionName":"操作名稱"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/tasks.json
// module id = tdlC
// module chunks = 3